import NBType, { InferType } from '@netbase/nb-type'

const QuidTopicTypeSchema = NBType.object().shape('QuidTopicTypeSchema', {
  /* @prop */
  broadTopic: NBType.string(),
  /* @prop */
  groupTopic: NBType.string()
  /* END */
})
export default QuidTopicTypeSchema
export type QuidTopicType = InferType<typeof QuidTopicTypeSchema>
// RESERVE BELOW
